import { GET_OUTPUT_COLUMNS, SET_VIEW_OUTPUT_COLUMNS } from 'app/lib/types/server';
import { createActionType, createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('columnManagement');
const type = createActionType('columnManagement');

export const CANCEL_QUERY_TYPE = type('CancelQuery');

export const GET_OUTPUT_COLUMNS_ACTION_TYPE = apiType(GET_OUTPUT_COLUMNS);

export const SET_OUTPUT_COLUMNS_ACTION_TYPE = apiType(SET_VIEW_OUTPUT_COLUMNS);
export const SET_LOCAL_MAPPING = type('SetLocalMapping');
export const PREVIEW = type('Preview');
export const CLOSE = type('Close');
